import type { NextPage } from "next";
import { NskHead } from "~/components/common/head/NskHead";
import { Page as Component } from "~/containers/specifics/deals/Page";

export const PATH = "/deals";

const DealsIndex: NextPage = () => (
	<>
		<NskHead title="案件一覧" />
		<Component />
	</>
);

export default DealsIndex;
